<template>
  <div
      class="position-relative photo-list-item"
      @click="$emit('clicked')">
      <PhotoThumbnail
        v-if="isModalTriggering"
        class="photo-list-img clickable"
        :photoId="item.id"
        :quality="'240'" 
        :textAlternative="item.title"
        data-bs-toggle="modal"
        data-bs-target="#photo-modal-component"/>
      <PhotoThumbnail
        v-else
        :class="photoThumbnailClass"
        :photoId="item.id"
        :quality="'720'" 
        :textAlternative="item.title"/>
      <div
        v-if="isModalTriggering"
        class="position-absolute photos-list-content-title-name bg-dark bg-opacity-75 clickable text-small ps-1 pe-1"
        data-bs-toggle="modal"
        data-bs-target="#photo-modal-component">
        <p class="mb-1">{{ item.timestamp_created.replace("T", ' ') }}</p>
        <p v-if="item.title" class="mb-1 text-uppercase">{{ item.title }}</p>
        <p v-if="item.legend" class="mb-1">{{ getLegend(item.legend) }}</p>
      </div>
      <div
        v-else
        :class="'position-absolute photos-list-content-title-name bg-dark bg-opacity-75 text-small ps-1 pe-1' + (item.title !== '' ? ' clickable': '')"
        class="position-absolute photos-list-content-title-name bg-dark bg-opacity-75 clickable text-small ps-1 pe-1">
        <p v-if="item.title" class="mb-1 mt-1">{{ item.title }}</p>
        <p v-if="item.legend" class="mb-1">{{ getLegend(item.legend) }}</p>
      </div>
      <div
          v-if="!isHome && hasCartAccess"
          class="position-absolute photos-list-cart-add-remove-buttons-container ms-2">
          <ButtonAddToCart :item="item" :canHide="true"/>
          <ButtonRemoveFromCart :item="item"  :canHide="true"/>
      </div>
      <div
        v-if="!isModalTriggering && item.title === ''"
        class="position-absolute bg-danger bg-opacity-75 text-medium fw-bold p-1 top-0 start-0 end-0">
        {{ languageStore.text(TEXT_KEYS.PHOTO_ITEM_LIST_HOME_NO_TITLE) }}
      </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue, prop } from "vue-class-component";

import { useUserStore } from "@/stores/user";
import { useImageStore } from "@/stores/image";
import { useLanguageStore } from "@/stores/language";

import {
  TEXT_KEYS,
  PHOTO_LIST_LEGEND_NUM_CHARACTERS,
  FEATURES } from "@/constants";

import ButtonAddToCart from "@/components/ButtonAddToCart.vue"; // @ is an alias to /src
import ButtonRemoveFromCart from "@/components/ButtonRemoveFromCart.vue"; // @ is an alias to /src
import PhotoThumbnail from "@/components/common/PhotoThumbnail.vue";

// Define props in a class
class PhotoListItemProps {
  item = prop({
    // Same as Vue core's prop option
    type: Object,
    required: true,
    default: {}
  })
  isModalTriggering = prop({
    // Same as Vue core's prop option
    type: Boolean,
    required: false,
    default: false
  })
  isHome = prop({
    // Same as Vue core's prop option
    type: Boolean,
    required: false,
    default: true
  })
}

@Options({
  components: {
    ButtonAddToCart,
    ButtonRemoveFromCart,
    PhotoThumbnail
  }
})
export default class PhotoListItem extends Vue.with(PhotoListItemProps) {
  imageStore = useImageStore()
  userStore = useUserStore()
  languageStore = useLanguageStore()

  PHOTO_LIST_LEGEND_NUM_CHARACTERS = PHOTO_LIST_LEGEND_NUM_CHARACTERS
  TEXT_KEYS = TEXT_KEYS

  photoThumbnailClass = 'photo-list-img' + (this.item.title !== '' ? ' clickable': '')

  get hasCartAccess() {
    return this.userStore.checkFeatureAccess(FEATURES.CART)
  }

  getLegend(legend: string): string {
    let legendTruncated: string = legend

    if (legend.length > PHOTO_LIST_LEGEND_NUM_CHARACTERS) {
      legendTruncated = legend.slice(0, PHOTO_LIST_LEGEND_NUM_CHARACTERS).concat("...")
    }

    return legendTruncated
  }
}
</script>

<style lang="stylus">
.photo-list-item {
  height: 18rem;
}

.photo-list-item:hover {
  border-radius: 0.75rem;
  border-color: #e2001a;
  border-width: 2px;
  border-style: solid;
}

.photo-list-img { 
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>
